export default __webpack_public_path__ + "static/media/icon_exclamation.6eaf3ab2.png";